module.exports = __webpack_public_path__ + "static/media/minesweeper_promo.87dd7fc8.png";